import { createSlice } from '@reduxjs/toolkit';

import { noop } from '@constants/general';
import { STATUS } from '@constants/status';

export const initialState = {
  model: {},
  meta: {
    errorMessage: '',
    status: STATUS.LOADING,
  },
};

const aggregates = createSlice({
  name: 'aggregates',
  initialState,
  reducers: {
    resetAggregates: state => {
      state.model = initialState.model;
      state.meta = initialState.meta;
    },
    requestAggregates: state => {
      state.model = initialState.model;
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    },
    requestAggregatesECSL: state => {
      state.meta.errorMessage = '';
      state.meta.nextQuery = undefined;
      state.meta.status = STATUS.LOADING;
    },
    requestAggregatesECSLSuccess: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.model = { ...action.payload.result.data, totals: action.payload.result.totals };
      state.meta.nextQuery = action.payload.result.nextQuery;
    },
    requestAggregatesECSLFailure: (state, action) => {
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = action.payload.errorMessage;
    },
    requestAdditionalAggregatesECSL: state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.UPDATING;
    },
    requestAdditionalAggregatesECSLSuccess: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.model[action.payload.result.type].rows = state.model[
        action.payload.result.type
      ].rows.concat(action.payload.result.data[action.payload.result.type].rows);
      state.meta.nextQuery = action.payload.result.nextQuery;
    },
    requestAdditionalAggregatesECSLFailure: state => {
      state.meta.status = STATUS.ERROR;
    },
    requestAggregatesItaly: state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    },
    requestAggregatesSuccess: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.model = action.payload;
    },
    requestAggregatesFailure: (state, action) => {
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = action.payload.errorMessage;
    },
    processingAggregatesRequest: noop,
    processingAggregatesStart: noop,
    processingAggregatesStop: noop,
    processingAggregatesSuccess: (state, action) => {
      state.model = action.payload;
    },
  },
});

export const {
  requestAggregatesFailure,
  requestAggregatesSuccess,
  requestAggregates,
  requestAggregatesECSL,
  requestAggregatesECSLSuccess,
  requestAggregatesECSLFailure,
  requestAdditionalAggregatesECSL,
  requestAdditionalAggregatesECSLSuccess,
  requestAdditionalAggregatesECSLFailure,
  requestAggregatesItaly,
  resetAggregates,
  processingAggregatesStart,
  processingAggregatesStop,
  processingAggregatesRequest,
  processingAggregatesSuccess,
} = aggregates.actions;
export default aggregates.reducer;
